import React from "react";
import "./PaymentProcess.css";

const PaymentProcess = () => {
  return (
    <div className="payment-processing-body">
      <div className="loader"></div>
      <div className="text">Payment processing, please wait…</div>
    </div>
  );
};

export default PaymentProcess;
